export const VEGETARIAN_ARTICLE = {
  path: "/blog/vegetarian-cambodian-food-melbourne",
  title: "Vegetarian Cambodian Food in Melbourne: What to Order at ANGKOR",
  headline: "Vegetarian Cambodian Food in Melbourne: What to Order at ANGKOR",
  description:
    "A plant-friendly guide to Cambodian food in Melbourne: tofu red curry, papaya salad (vegan option), spring rolls, lemongrass fried rice and desserts at ANGKOR, 389 Spencer St.",
  image: "/manus-storage/cambodian-curry-premium_23eefa20.webp",
  imageSrcSet:
    "/manus-storage/cambodian-curry-premium-480_13688488.webp 480w, /manus-storage/cambodian-curry-premium-800_a6588971.webp 800w, /manus-storage/cambodian-curry-premium_23eefa20.webp 1600w",
  imageAlt: "Traditional Cambodian red curry at ANGKOR West Melbourne",
  datePublished: "2026-10-28",
  dateLabel: "28 October 2026",
  byline: "By the ANGKOR team",
  excerpt:
    "A plant-friendly guide to Cambodian food at ANGKOR in West Melbourne.",
} as const;
